.container {
  position: relative;
}

.trigger {
  display: flex;
  align-items: center;
  gap: var(--qs-space-8);
  min-width: var(--qs-target-min);
  min-height: var(--qs-target-min);
  padding: 0 var(--qs-space-12);
  border: none;
  border-radius: var(--qs-radius-pill);
  background: transparent;
  color: var(--qs-color-text-soft);
  cursor: pointer;
  transition: opacity var(--qs-motion-dur-fade) var(--qs-motion-ease-settle);

  &:hover:not(:disabled) {
    color: var(--qs-color-text);
  }

  &.disabled,
  &:disabled {
    opacity: 0.45;
    pointer-events: none;
  }
}

.initial {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid var(--qs-color-line-strong);
  font-family: var(--qs-font-display);
  font-style: italic;
  font-size: 13px;
}

.triggerLabel {
  font-size: var(--qs-type-label-size);

  @media (max-width: 719px) {
    display: none;
  }
}

.popover {
  position: absolute;
  top: calc(100% + var(--qs-space-8));
  right: 0;
  width: 280px;
  max-height: 340px;
  overflow-y: auto;
  padding: var(--qs-space-12);
  border-radius: var(--qs-radius-md);
  background: var(--qs-color-surface-raised);
  border: 1px solid var(--qs-color-line);
  box-shadow: var(--qs-elev-popover);
  z-index: 40;
  animation: settle var(--qs-motion-dur-settle) var(--qs-motion-ease-settle);

  @media (max-width: 719px) {
    position: fixed;
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    max-height: 60vh;
    border-radius: var(--qs-radius-lg) var(--qs-radius-lg) 0 0;
  }
}

@keyframes settle {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

.voiceList {
  display: flex;
  flex-direction: column;
  gap: var(--qs-space-8);
}

.pill {
  display: flex;
  align-items: center;
  gap: var(--qs-space-8);
  padding: var(--qs-space-4);
  border-radius: var(--qs-radius-pill);
  border: 1.5px solid transparent;

  &.chosen {
    border-color: var(--qs-color-text);
    background: var(--qs-color-surface-raised);
  }
}

.preview {
  flex: none;
  width: var(--qs-target-min);
  height: var(--qs-target-min);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid var(--qs-color-line);
  background: transparent;
  color: var(--qs-color-text-soft);
  cursor: pointer;

  &.previewing {
    background: var(--qs-color-glow-core);
    color: var(--qs-color-on-light);
    border-color: transparent;
  }
}

.name {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  gap: var(--qs-space-8);
  min-height: var(--qs-target-min);
  padding: 0 var(--qs-space-12) 0 var(--qs-space-4);
  font-family: var(--qs-font-display);
  font-style: italic;
  font-size: var(--qs-type-display-xs-size);
  color: var(--qs-color-text);
  cursor: pointer;

  input {
    position: absolute;
    opacity: 0;
    width: var(--qs-target-min);
    height: var(--qs-target-min);
    margin: 0;
    cursor: pointer;
  }
}

.check {
  color: var(--qs-color-accent);
  margin-left: auto;
}
